<template>
  <q-dialog 
    :visible="isVisible" 
    title="通知店铺" 
    width="500px" 
    :innerScroll="false" 
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div class="notify-content">
      <div class="notify-desc">
        确定后，系统将通过YOLINK给已上架店铺相关负责人发送系统通知
      </div>
      
      <el-form :model="form" :rules="rules" ref="form" size="mini" label-width="110px">
        <el-form-item label="通知时间" prop="noticeTime" required>
          <el-select v-model="form.noticeTime" placeholder="请选择">
            <el-option label="立即通知" value="0"></el-option>
            <el-option 
              v-for="timeOption in timeOptions" 
              :key="timeOption.value" 
              :label="timeOption.label" 
              :value="timeOption.value"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="通知紧急程度" prop="isEmergency" required>
          <el-radio-group v-model="form.isEmergency">
            <el-radio label="1">紧急</el-radio>
            <el-radio label="0">不紧急</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showPlatform" label="接收平台" prop="platformList" :required="platformRequired">
          <el-select v-model="form.platformList" multiple collapse-tags placeholder="请选择平台" @change="handlePlatformChange">
            <el-option
              v-for="item in platformOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="调整备注：" prop="adjustRemark">
          <el-input 
            type="textarea" 
            v-model="form.adjustRemark" 
            :rows="4"
            placeholder="请输入调整备注"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
  </q-dialog>
</template>

<script>
import moment from 'moment';

export default {
  name: 'NotifyStoreDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showPlatform: {
      type: Boolean,
      default: false
    },
    platformRequired: {
      type: Boolean,
      default: false
    },
    platformOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    timeOptions() {
      const options = [];
      const now = new Date();
      
      // 当前时间 + 50分钟
      const baseTime = new Date(now.getTime() + 50 * 60 * 1000);
      // 向上取整到下一个整点
      baseTime.setMinutes(0, 0, 0);
      baseTime.setHours(baseTime.getHours() + 1);
      
      for (let i = 0; i < 24; i++) {
        const futureTime = new Date(baseTime);
        futureTime.setHours(baseTime.getHours() + i);
        
        const timeStr = futureTime.toLocaleString('zh-CN', {
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
        
        options.push({
          label: timeStr,
          value: futureTime.toISOString()
        });
      }
      
      return options;
    }
  },
  data() {
    return {
      previousPlatformList: [],
      form: {
        noticeTime: '0',
        isEmergency: '',
        platformList: [],
        adjustRemark: ''
      },
      rules: {
        noticeTime: [
          { required: true, message: '请选择通知时间', trigger: 'change' }
        ],
        isEmergency: [
          { required: true, message: '请选择通知紧急程度', trigger: 'change' }
        ],
        platformList: [
          {
            validator: (rule, value, callback) => {
              if (this.showPlatform && this.platformRequired && (!value || !value.length)) {
                callback(new Error('请选择接收平台'));
                return;
              }
              callback();
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.platformList = this.showPlatform ? ['all'] : [];
        this.previousPlatformList = [...this.form.platformList];
      }
    }
  },
  methods: {
    handlePlatformChange(val) {
      const currentList = Array.isArray(val) ? [...val] : [];
      const hasAll = currentList.includes('all');
      const prevHasAll = this.previousPlatformList.includes('all');
      if (hasAll && currentList.length > 1) {
        this.form.platformList = prevHasAll
          ? currentList.filter(item => item !== 'all')
          : ['all'];
      } else {
        this.form.platformList = currentList;
      }
      this.previousPlatformList = [...this.form.platformList];
    },
    onCancel() {
      this.isVisible = false;
      this.resetForm();
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let platformList = this.form.platformList;
          if (this.showPlatform) {
            platformList = platformList.includes('all')
              ? this.platformOptions.filter(item => item.value !== 'all').map(item => item.value).join(',')
              : platformList.join(',');
          }
          let data = {
            ...this.form,
            platformList,
            noticeTime: this.form.noticeTime != '0' ? moment(this.form.noticeTime).format('YYYY-MM-DD HH:mm:ss') : 0

          }
          console.log("🚀 ~ onConfirm ~ data:", data)
          this.$emit('confirm', data);
          this.isVisible = false;
          this.resetForm();
        }
      });
    },
    resetForm() {
      this.form = {
        noticeTime: '0',
        isEmergency: '',
        platformList: this.showPlatform ? ['all'] : [],
        adjustRemark: ''
      };
      this.previousPlatformList = [...this.form.platformList];
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
// .notify-content
//   padding: 20px
  
.notify-desc
  color: #666
  font-size: 14px
  margin-bottom: 20px
  line-height: 1.5
</style>

